import React, { FC, useEffect, useMemo, useRef, useState } from "react";
import { useOutsideClick } from 'hooks/useOutsideClick';
//components
import QuotesStockInfo from "pages/Quotes/components/QuotesStockInfo";
import Loader from "pages/Quotes/components/generics/Loader";
import { Visibility } from "components/Visibility";
import toast from 'components/Toast/dispatch';
import { Button } from "components/Button";
//images
import downloadTechnicalSheetBtn from "img/download-technical-sheet.svg";
import priceHistoryBtn from "img/icon-price-history.svg";
import itemValidity from "img/item-validity.svg";
//interface
import { IActionIcons } from "./interface";
//context
import { useDetailsQuoteContext } from "contexts/DetailsQuote";
//service
import ProductService from 'services/product.service';
//utils
import { handleCreatePdf } from "pages/Quotes/Dashboard/utils";
import { IsNullOrEmpty } from "utils/StringNullOrEmpty";
import { DisableButton } from "utils/DisableButton";
//styles
import './style.scss';

const ActionIcons: FC<IActionIcons> = ({
  distributionCenterSelected,
  setwarningToolTip,
  isMapProductView,
  quoteDetailItem,
  warningToolTip,
  selectedCDItem,
  notifyLoading,
  customerCode,
  suggested,
  quoteId,
  isOrder,
  item,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const [showExtra, setShowExtra] = useState(false);
  const [stock, setStock] = useState(item?.itemStock?.find((elem: any) => elem.local === item?.distributionCenter));
  const wrapperRef = useRef(null);
  useOutsideClick(wrapperRef, setwarningToolTip);

  const {
    setShowPriceHistoryModal,
    showPriceHistoryModal,
    setItemPriceHistory,
    setSequenceNumber,
    setQuoteDetail,
    isQuoteExpired,
    quoteDetail
  } = useDetailsQuoteContext();

  const ableNegotiacionBtn = (isQuoteExpired && IsNullOrEmpty(quoteDetail?.distributionCentersNegotiation?.find((item) => item === distributionCenterSelected)));

  useEffect(() => {
    setStock(item?.itemStock?.find((elem: any) => elem.local === item?.distributionCenter));
  }, [item]);

  const itemBatchess = useMemo(() =>
    suggested?.itemBatch?.find((item: any) => item.distributionCenter === selectedCDItem),
    [item, selectedCDItem]);

  const suggestedValidityAlertt = itemBatchess?.validityAlert;
  const _productService = new ProductService();

  const openWarningTooltip = () => {
    setwarningToolTip(!warningToolTip);
    setShowExtra(false);
  };

  const handleShowPriceHistoryModal = () => {
    if (!IsNullOrEmpty(quoteDetailItem)) setQuoteDetail(quoteDetailItem);
    setShowPriceHistoryModal(true);
    setItemPriceHistory({
      ...item,
      QuoteId: quoteId,
      commercialCost: stock,
      crmCustomerCode: customerCode,
      rentability: item.rentability,
      factoryPrice: stock?.factoryPrice,
      priorityBCG: item.priorityBCG
    });
    setSequenceNumber(item.sequenceNumber);
  };

  const handleDownloadTechnicalSheetBtn = async (supplierProductcode: any) => {
    setIsDownloading(true);
    _productService.getDownloadTechnicalSheet(supplierProductcode).then((response: any) => {
      if (response.status === 200) {
        handleCreatePdf(response, "FichaTecnica-Produto", supplierProductcode);
      } else {
        toast.error('Ocorreu um erro durante a requisição');
      }
    }).finally(() => {
      setIsDownloading(false);
    });
  };

  useEffect(() => {
    if (showPriceHistoryModal) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "visible";
    }
  }, [showPriceHistoryModal]);

  useEffect(() => {
    notifyLoading(isLoading);
  }, [isLoading]);

  return (
    <>
      <div className="icons">
        <div className="iconsStock">
          <Visibility visible={suggested?.itemStock}>
            {suggested?.itemStock && (
              <QuotesStockInfo
                showExtra={showExtra}
                setShowExtra={setShowExtra}
                stockInfo={suggested?.itemStock}
              />
            )}
          </Visibility>
        </div>
        <Visibility visible={suggested?.itemStock && itemBatchess && suggestedValidityAlertt && !isOrder && !isMapProductView}>
          <div className="iconsValidity" ref={wrapperRef}>
            <img
              onClick={openWarningTooltip}
              src={itemValidity}
              alt="modal de validade dos lotes"
            />
          </div>
        </Visibility>
        <Visibility visible={suggested?.itemStock && suggested?.itemStock.length > 0 && item.itemStock && !isOrder}>
          <div className="history">
            {isLoading ? (
              <div className="loadEditPriceHistory">
                <Loader className="loaderPriceHistory" size={20} />
              </div>
            ) : (
              <div className="IconsPriceHistory">
                <Button className="IconsPriceHistoryButton" onClick={() => !ableNegotiacionBtn && handleShowPriceHistoryModal()}>
                  <img src={priceHistoryBtn} className={`${DisableButton(ableNegotiacionBtn)}`} />
                </Button>
              </div>
            )}
          </div>
        </Visibility>
        <Visibility visible={suggested?.itemStock && item.itemStock}>
          <div>
            {isLoading ? (
              <div className="loadEditPriceHistory">
                <Loader className="loaderPriceHistory" size={20} />
              </div>
            ) : (
              <div className="IconsDownloadSheet">
                {isDownloading ?
                  <Loader withPadding={false} size={16} />
                  :
                  <Button tooltip="Download ficha técnica" className="IconsDownloadSheetButton" onClick={() => handleDownloadTechnicalSheetBtn(item.supplierProductcode)}>
                    <img src={downloadTechnicalSheetBtn} />
                  </Button>
                }
              </div>
            )}
          </div>
        </Visibility>
      </div>
    </>
  );
};

export default ActionIcons;
